import script from "./chooseMerchant.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseMerchant.vue?vue&type=script&setup=true&lang=js"

import "./chooseMerchant.vue?vue&type=style&index=0&id=cd90d4a4&lang=scss"

const __exports__ = script;

export default __exports__